import React, { FC } from "react";
import { CalculationHistoryProps } from "store/replenishment/types";
import moment from "moment";

interface NotificationProps {
  item: CalculationHistoryProps;
  color: string;
}

const NotificationItem: FC<NotificationProps> = ({ item, color }) => {
  return (
    <div
      style={{
        backgroundColor: color,
        display: "flex",
        flexDirection: "column",
        fontSize: "12px",
        fontFamily: "Lato",
        borderBottom: "0.5px solid #DBDBDB",
        padding: "14px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{ margin: "0", color: "rgba(0, 0, 0, 0.6)", fontSize: "12px" }}
        >
          {item.Metadata.jobName}
        </p>
        <p style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "8px" }}>
          {new Date().toLocaleDateString("en")}
        </p>
      </div>
      <div>
        <p
          style={{
            margin: "0",
            color: "rgba(0, 0, 0, 0.87)",
            fontSize: "12px",
            marginTop: "2px",
            fontWeight: 600,
          }}
        >
          {item.Status}
        </p>
      </div>
      <div>
        <p
          style={{
            margin: "0",
            color: "rgba(0, 0, 0, 0.87)",
            fontSize: "12px",
            marginTop: "2px",
          }}
        >
          Created : {moment(item.CreatedAt).fromNow()}
        </p>
        <p
          style={{
            margin: "0",
            color: "rgba(0, 0, 0, 0.87)",
            fontSize: "12px",
            marginTop: "2px",
          }}
        >
          Updated : {moment(item.UpdatedAt).fromNow()}
        </p>
      </div>
    </div>
  );
};

export default NotificationItem;
